import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';



/**
 * アイテム情報を削除するクラス
 *
 * @export DeleteGoodsDetailService
 * @class DeleteGoodsDetailService
 * @extends {PlessResponder}
 */
@Injectable()
export class DeleteGoodsDetailService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private vo: Array<any>;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteGoodsDetailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.vo[0],
        ItemCode: this.vo[1]
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof DeleteGoodsDetailService
   */
  execute(model: KYMW1100Model, vo: Array<any>, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deleteGoodsDetail', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteGoodsDetailService
   */
  success(data: any): void {
    // Item情報初期化。
    this.model.kymw1100Component.setWindowVisible('ITEM_CHANGE');

    // item情報
    this.model.updateGoodsDatailData(data);

    this.model.updateGoodsCoopList(data);

    this.model.updateGoodsCoopWkList(data);

    this.model.setConsumeTaxPrice(this.model.getEditCoopInfoList());

    this.model.updateSpecifications1List(data);

    this.model.updateGoodsAllergenList(data);

    this.model.updateGoodsNutrientInfo(data);

    this.model.updateGoodsEcologyList(data);

    this.model.updateGoodsGWStopList(data);

    this.model.updateContainPackingList(data);

    // janCodeDivによるインストア採番ボタン制御。
    this.model.kymw1100Component.setItemInstallButton();

    // 「eBASEデータ」ボタンの活性制御を行う。
    this.model.kymw1100Component.setWindowVisible('EBASE');
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
